import { FilterBar, FilterRow } from "@components/FilterBar";
import ObjectSelect from "@components/ObjectSelect";
import { type ExplodedErrorRow, errorColumns, useExplodedErrors } from "@features/communications";
import { useCommunicationState } from "@features/communications/api";
import { useObjects } from "@features/devices/api";
import { PageLayoutWithHelp } from "@features/page-help";
import { useGlobalObject } from "@shared/hooks/useGlobalObject";
import EnterpriseTable from "@shared/ui/enterprise-table";
import { Alert, Flex, Typography } from "antd";

const CommunicationErrorsPage = () => {
  const objectsQuery = useObjects();
  const objects = objectsQuery.data ?? [];
  const { selectedObject, setSelectedObject } = useGlobalObject(objects, { required: false });

  const stateQuery = useCommunicationState({
    region: selectedObject?.regionId,
    object: selectedObject?.objectId,
    limit: 500,
  });

  const data = useExplodedErrors(stateQuery.data);

  return (
    <PageLayoutWithHelp title="Ошибки счётчиков и УСПД">
      <Flex vertical gap="large" style={{ width: "100%" }}>
        <Typography.Text type="secondary">
          Таблица показывает устройства, по которым зафиксированы ошибки связи, протокола или
          внутренние статусные коды.
        </Typography.Text>

        <FilterBar>
          <FilterRow>
            <ObjectSelect
              objects={objects}
              loading={objectsQuery.isLoading}
              value={selectedObject}
              onChange={setSelectedObject}
              allowClear
              placeholder="Объект (все доступные)"
              style={{ minWidth: 320 }}
            />
          </FilterRow>
        </FilterBar>

        {!stateQuery.isLoading && data.length === 0 ? (
          <Alert type="success" showIcon title="Ошибок не обнаружено" />
        ) : (
          <EnterpriseTable<ExplodedErrorRow>
            rowKey={(row) => row.row_key}
            columns={errorColumns}
            dataSource={data}
            loading={stateQuery.isLoading}
            scroll={{ x: 900 }}
            size="small"
            toolbar={{ reload: true, onReload: () => stateQuery.refetch() }}
          />
        )}
      </Flex>
    </PageLayoutWithHelp>
  );
};

export default CommunicationErrorsPage;
